export const CUSTOM_FIELD_TYPE_ENTITY_SELECTOR = "ENTITY_SELECTOR";
export const CUSTOM_FIELD_TYPE_STATE_SELECTOR = "STATE_SELECTOR";
export const CUSTOM_FIELD_TYPE_COUNTRY_SELECTOR = "COUNTRY_SELECTOR";
export const CUSTOM_FIELD_TYPE_FORMATION_TYPES_SELECTOR =
  "FORMATION_TYPES_SELECTOR";
export const CUSTOM_FIELD_TYPE_ADDRESS_SELECTOR = "ADDRESS_SELECTOR";
export const CUSTOM_FIELD_TYPE_PERSONA_SELECTOR = "PERSONA_SELECTOR";
export const CUSTOM_FIELD_TYPE_INPUT = "INPUT";
export const CUSTOM_FIELD_TYPE_MONTH_PICKER = "MONTH_PICKER";
export const CUSTOM_FIELD_TYPE_YEAR_PICKER = "YEAR_PICKER";
export const CUSTOM_FIELD_TYPE_DATE_PICKER = "DATE_PICKER";
export const CUSTOM_FIELD_TYPE_PHONE_INPUT = "PHONE_INPUT";
export const CUSTOM_FIELD_TYPE_COMBOBOX = "COMBOBOX";
export const CUSTOM_FIELD_TYPE_RADIO = "RADIO";
export const CUSTOM_FIELD_TYPE_CHECKBOX = "CHECKBOX";
export const CUSTOM_FIELD_TYPE_AMOUNT_INPUT = "AMOUNT_INPUT";
export const CUSTOM_FIELD_TYPE_STRING = "STRING";
